import React from "react";
import { SvgIcon } from '@material-ui/core';
import clsx from 'clsx';
import { withStyles } from '@material-ui/styles';

const styles = theme => ({
  root: {
    width: 94,
    height: 102
  }
});

class MybilioLogoBronze extends React.Component {

  render() {
    const { classes, className } = this.props;

    return <SvgIcon className = { clsx(classes.root, className) }
                    viewBox = { "0 0 94 102" } >
      <path d="M3 27.5586V79.0238L46.9989 99.3124V96.7727L46.9754 96.7605V50.5152L91 27.365L46.2064 3L46.1914 9.83622V10.5129V11.0469V47.7207L3 27.5586ZM46.9754 47.7085V6.15722L85.902 27.3874L46.9754 47.7085ZM5.63252 31.5739L46.1871 50.507V96.1409L5.63252 77.4626V31.5739Z" fill="#C27100"/>
    </SvgIcon>
  }
}

export default withStyles(styles)(MybilioLogoBronze);
